import React from 'react';
import { Link } from 'react-router-dom';
import { Lexicon, EditWrapper } from '@nitidbit/lexicon';
import text from './MenuLinksStrings.json';
import { LEXICON_URL } from '../../constants'

const MenuLinks = ({ lexicon, setIsHamburgerOpen = null, setPosition = null /* isShowingVeteransLink = false */ }) => {
  const position = document.location.pathname === '/' ? 'home' : document.location.pathname.slice(1);
  // const isShowingVeteranSection = (new URLSearchParams(useLocation().search)).get('section') === 'veterans';
  // if (position === 'patients' && isShowingVeteranSection) position += '-veterans';

  // console.log(setIsHamburgerOpen)


  const captureBubbling = (e) => {
    if (setPosition) setPosition(e.target.id);
    if (setIsHamburgerOpen) setIsHamburgerOpen(false);
  };

  return (
    <div role="presentation" onClick={captureBubbling}>
      <Link to="/" className={`home-link ${position}`} id="home">
        {lexicon.get('home')}
        <hr />
      </Link>
      <Link to="/patients" className={`patient-link ${position}`} id="patients">
        {lexicon.get('patients')}
        <hr />
      </Link>
      {/* {
        isShowingVeteransLink && (
          <Link to="/patients?section=veterans" className={`patient-link ${position}`} id="patients-veterans">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {lexicon.get('veterans')}
            <hr />
          </Link>
        )
      } */}
      <Link to="/providers" className={`provider-link ${position}`} id="providers">
        {lexicon.get('providers')}
        <hr />
      </Link>
      <Link to="/veterans" className={`veteran-link ${position}`} id="veterans">
        {lexicon.get('veterans')}
        <hr />
      </Link>
      <Link to="/about" className={`about-link ${position}`} id="about">
        {lexicon.get('about')}
        <hr />
      </Link>
    </div>
  );
};

const MenuLinksLexicon = new Lexicon(text, 'en', 'src/shared/MenuLinks/MenuLinksStrings.json');

const EditableMenuLinks = (props) => (
  <EditWrapper
    component={(wrapperProps) => <MenuLinks {...{ ...props, ...wrapperProps }} />}
    lexicon={MenuLinksLexicon}
    apiUpdateUrl={LEXICON_URL}
  />
);

export default EditableMenuLinks;
